import styled, { css } from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const ContainerIntegracaoBlingV2 = styled.div`
  margin: 5rem 0;
  min-height: 30rem;
  border-radius: 6rem;
  color: ${({theme}) => theme.colors.tertiary};
  .config {
    display: flex;
    align-items: center;
    margin: 3rem 0;
    .title {
      margin-left: 2rem;
      text-align: left;
      &.bloqueado {
        opacity: 0.5;
      }
    }
    > .locked-icon {
      margin-left: 1.5rem;
    }
  }

  .radioGroup {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin: 3rem 0;

    .radioTitle {
      margin-bottom: 0.5rem;
    }

    .radioLabel {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
      &.bloqueado {
        cursor: default;
        > span {
          opacity: 0.5;
        }
      }
      > .locked-icon {
        margin-left: 0.5rem;
      }
    }
  }
  .configs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 3rem;
    margin-top: 3rem;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  .obs{
    text-align: justify;

    span{
      font-weight: bold;
    }
  }

  .textoBling{
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding-bottom: 5rem;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .urlContainer{
    padding-top: 5rem;
    text-align: left;
    .url{
      cursor: pointer;
      color: ${({theme}) => theme.colors.primary};
      text-align: left;
      word-break: break-all;
      &:hover{
        text-decoration: underline;
      }
    }
  }
`;

export const ModalContainer = styled.div<{theme: ThemeType}>`
  padding: 5rem;
  .titulo{
    text-align: center;
    font-weight: bold;
    color: ${({theme}) => theme.colors.secondary};
    margin-bottom: 4rem;
  }
  
  .texto{
    text-align: center;
    margin-bottom: 4rem;
  }
  .botoes{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cancelar{
      cursor: pointer; 
    }
  }
`
